import React from "react";

const qtyClass = (value) => {
    if (value > 0) return "text-green-600";
    if (value < 0) return "text-red-600";
    return "text-gray-700";
};

const moneyClass = (value) => qtyClass(value);

const cell = "px-1 py-1.5 border border-gray-200 align-middle";
const hdr = "px-1 py-2 border border-gray-300 bg-slate-100 font-semibold text-[9px] text-slate-700 align-middle th-center whitespace-normal break-words leading-[1.15]";
const tdText = `${cell} td-text`;
const tdNum = `${cell} td-num`;
const tdCenter = `${cell} td-center`;

const TABLE_HEADERS = [
    "No.",
    "UPC",
    "Description",
    "Department",
    "Unit/Case",
    "Opening",
    "Item Purchase",
    "Item Sold",
    "Book Inventory",
    "On Hand",
    "Over/Short",
    "Each Cost",
    "Each Retail",
    "Total Cost",
    "Total Retail",
    "Total Cost O/S",
    "Total Retail O/S",
    "Action",
];

const InventoryLookupTable = ({ rows, onAdjust, adjustingUpc }) => {
    if (!rows?.length) {
        return (
            <div className="text-center text-gray-500 py-10 text-[15px]">
                No products found for this period and filter.
            </div>
        );
    }

    return (
        <div className="w-full overflow-hidden">
            <table className="w-full table-fixed border-collapse text-[10px] leading-tight">
                <colgroup>
                    <col className="w-[3%]" />
                    <col className="w-[8%]" />
                    <col className="w-[22%]" />
                    <col className="w-[7%]" />
                    <col className="w-[4%]" />
                    <col className="w-[4%]" />
                    <col className="w-[4%]" />
                    <col className="w-[4%]" />
                    <col className="w-[4%]" />
                    <col className="w-[4%]" />
                    <col className="w-[4%]" />
                    <col className="w-[4%]" />
                    <col className="w-[4%]" />
                    <col className="w-[5%]" />
                    <col className="w-[5%]" />
                    <col className="w-[5%]" />
                    <col className="w-[5%]" />
                    <col className="w-[5%]" />
                </colgroup>
                <thead>
                    <tr>
                        {TABLE_HEADERS.map((label) => (
                            <th key={label} className={hdr}>{label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => {
                        const busy = adjustingUpc === row.upc;
                        return (
                            <tr
                                key={row.upc}
                                className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} ${!row.in_price_book ? "bg-amber-50/40" : ""}`}
                            >
                                <td className={tdCenter}>{index + 1}</td>
                                <td className={`${tdNum} font-mono truncate`} title={row.upc}>
                                    {row.upc}
                                    {!row.in_price_book && (
                                        <span className="block text-[9px] text-amber-700 font-semibold truncate" title="Not in price book">*</span>
                                    )}
                                </td>
                                <td className={`${tdText} truncate`} title={row.description}>{row.description}</td>
                                <td className={`${tdText} truncate`} title={row.department}>{row.department}</td>
                                <td className={tdCenter}>{row.unit_case}</td>
                                <td className={tdCenter}>{row.opening_qty}</td>
                                <td className={`${tdCenter} text-indigo-600 font-semibold`}>{row.purchase_qty ?? 0}</td>
                                <td className={`${tdCenter} text-red-600`}>{row.sold_qty}</td>
                                <td className={`${tdCenter} font-semibold text-slate-700`}>{row.book_inventory_qty ?? 0}</td>
                                <td className={`${tdCenter} font-bold text-blue-700`}>{row.on_hand_qty}</td>
                                <td className={`${tdCenter} font-bold ${qtyClass(row.over_short_qty ?? 0)}`}>
                                    {row.over_short_qty ?? 0}
                                </td>
                                <td className={tdNum}>${Number(row.each_cost).toFixed(2)}</td>
                                <td className={tdNum}>${Number(row.each_retail).toFixed(2)}</td>
                                <td className={tdNum}>${Number(row.total_cost).toFixed(2)}</td>
                                <td className={tdNum}>${Number(row.total_retail).toFixed(2)}</td>
                                <td className={`${tdNum} font-semibold ${moneyClass(row.total_cost_overshot ?? 0)}`}>
                                    ${Number(row.total_cost_overshot ?? 0).toFixed(2)}
                                </td>
                                <td className={`${tdNum} font-semibold ${moneyClass(row.total_retail_overshot ?? 0)}`}>
                                    ${Number(row.total_retail_overshot ?? 0).toFixed(2)}
                                </td>
                                <td className={tdCenter}>
                                    <div className="flex items-center justify-center gap-0.5">
                                        <button
                                            type="button"
                                            disabled={busy}
                                            onClick={() => onAdjust(row.upc, "sold")}
                                            className="w-6 h-6 rounded bg-red-50 hover:bg-red-100 text-red-600 disabled:opacity-40"
                                            title="Record sold (-1)"
                                        >
                                            <i className="fa-solid fa-minus text-[9px]" />
                                        </button>
                                        <button
                                            type="button"
                                            disabled={busy}
                                            onClick={() => onAdjust(row.upc, "adjust_plus")}
                                            className="w-6 h-6 rounded bg-green-50 hover:bg-green-100 text-green-600 disabled:opacity-40"
                                            title="Add adjustment (+1)"
                                        >
                                            <i className="fa-solid fa-plus text-[9px]" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default InventoryLookupTable;
